/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./bioMatrixScanDetail.vue?vue&type=template&id=b8297b2a&scoped=true"
import script from "./bioMatrixScanDetail.vue?vue&type=script&lang=js"
export * from "./bioMatrixScanDetail.vue?vue&type=script&lang=js"
import style0 from "./bioMatrixScanDetail.vue?vue&type=style&index=0&id=b8297b2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8297b2a",
  null
  
)

export default component.exports